import { deploymentsApi } from '../api/deploymentsApi';
import { deploymentQueryKey } from './useDeployment';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

export const useDeleteDeploymentItem = (
  deploymentId: string,
  options: DeploymentMutationOptions<{ deleted: boolean }> = {}
) =>
  useDeploymentMutation<number, { deleted: boolean }>({
    mutationFn: (itemId) => deploymentsApi.deleteItem(deploymentId, itemId),
    invalidate: (qc) =>
      qc.invalidateQueries({ queryKey: deploymentQueryKey(deploymentId) }),
    errorLabel: 'Error deleting deployment item',
    ...options,
  });
